var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "prepare container" },
    [
      _c("Loading", { attrs: { loadingHide: _vm.loadingHide } }),
      _vm._v(" "),
      _vm.lessonName
        ? _c("h2", [_vm._v(_vm._s(`《${_vm.lessonName}》 ${_vm.type}`))])
        : _vm._e(),
      _vm._v(" "),
      _vm.imageText.length
        ? _c("ImageTextResource", { attrs: { imageText: _vm.imageText } })
        : _vm._e(),
      _vm._v(" "),
      _vm.video.length
        ? _c("VideoResource", { attrs: { video: _vm.video } })
        : _vm._e(),
      _vm._v(" "),
      _vm.audio.length
        ? _c("AudioResource", { attrs: { audio: _vm.audio } })
        : _vm._e(),
      _vm._v(" "),
      _vm.doc.length
        ? _c("DocResource", { attrs: { doc: _vm.doc } })
        : _vm._e(),
      _vm._v(" "),
      _vm.type == "作业"
        ? _c("ExercisesResource", {
            attrs: { testId: _vm.testId, classRecordId: _vm.classRecordId },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/resource/resource.vue?vue&type=template&id=4046fac5&scoped=true&
// module id = null
// module chunks = 